export const checkArrow = (
  <svg
    width="10"
    height="8"
    viewBox="0 0 10 8"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M8.66775 0.255056C8.84055 0.089653 9.07051 -0.00178848 9.30909 2.65108e-05C9.54768 0.0018415 9.77623 0.0967713 9.94653 0.264784C10.1168 0.432797 10.2155 0.660752 10.2218 0.900549C10.2282 1.14034 10.1416 1.37323 9.98033 1.55005L5.08574 7.70436C5.00157 7.79551 4.89999 7.86865 4.78707 7.91942C4.67415 7.97018 4.5522 7.99754 4.42853 7.99984C4.30485 8.00214 4.18198 7.97935 4.06726 7.93282C3.95255 7.88629 3.84835 7.81698 3.76088 7.72903L0.514995 4.46564C0.424602 4.38096 0.352101 4.27884 0.301815 4.16537C0.25153 4.05191 0.224491 3.92942 0.222311 3.80522C0.220132 3.68102 0.242856 3.55765 0.289129 3.44248C0.335402 3.3273 0.404276 3.22267 0.491641 3.13483C0.579006 3.047 0.683073 2.97775 0.797633 2.93123C0.912194 2.88471 1.0349 2.86186 1.15844 2.86405C1.28197 2.86624 1.4038 2.89343 1.51666 2.94398C1.62951 2.99454 1.73108 3.06743 1.81531 3.15831L4.38406 5.73967L8.64444 0.28219L8.66775 0.255056Z" />
  </svg>
);

export const hamburger = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="30"
    height="21"
    viewBox="0 0 30 21"
    fill="none"
  >
    <path
      d="M1.66667 20.5H28.3333C29.25 20.5 30 19.75 30 18.8333C30 17.9167 29.25 17.1667 28.3333 17.1667H1.66667C0.75 17.1667 0 17.9167 0 18.8333C0 19.75 0.75 20.5 1.66667 20.5ZM1.66667 12.1667H28.3333C29.25 12.1667 30 11.4167 30 10.5C30 9.58333 29.25 8.83333 28.3333 8.83333H1.66667C0.75 8.83333 0 9.58333 0 10.5C0 11.4167 0.75 12.1667 1.66667 12.1667ZM0 2.16667C0 3.08333 0.75 3.83333 1.66667 3.83333H28.3333C29.25 3.83333 30 3.08333 30 2.16667C30 1.25 29.25 0.5 28.3333 0.5H1.66667C0.75 0.5 0 1.25 0 2.16667Z"
      fill="#181818"
    />
  </svg>
);

export const cart = (
  <svg
    width="17"
    height="16"
    viewBox="0 0 17 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M5.98837 12.0457H14.5842C14.8711 12.0457 15.1216 11.7853 15.1216 11.4353C15.1216 11.0853 14.8711 10.8249 14.5842 10.8249H6.11345C5.69359 10.8249 5.43589 10.4992 5.36958 10.003L5.25173 9.14852H14.5987C15.6741 9.14852 16.2266 8.41588 16.3812 7.25235L16.9705 2.94715C16.9861 2.84492 16.996 2.74171 17 2.63812C17 2.2475 16.7348 1.97875 16.3297 1.97875H4.3017L4.16153 0.945418C4.08799 0.318684 3.88184 0.000976562 3.13074 0.000976562H0.54494C0.250471 0.000976562 0 0.286392 0 0.612086C0 0.945418 0.250471 1.23049 0.545255 1.23049H3.03457L4.21307 10.1659C4.36801 11.3214 4.92018 12.0457 5.98837 12.0457ZM15.7476 3.20756L15.2253 7.10582C15.1662 7.61033 14.9233 7.9197 14.4887 7.9197L5.09019 7.92769L4.46386 3.20756H15.7476ZM6.5704 16.0009C6.72746 16.0024 6.88321 15.9692 7.02857 15.9035C7.17394 15.8377 7.306 15.7407 7.41706 15.618C7.52813 15.4953 7.61597 15.3494 7.67548 15.1888C7.73499 15.0282 7.76497 14.8561 7.76367 14.6825C7.76434 14.5092 7.73392 14.3374 7.67419 14.1771C7.61446 14.0168 7.52659 13.8712 7.41565 13.7486C7.30471 13.6261 7.1729 13.529 7.02783 13.463C6.88275 13.397 6.72729 13.3634 6.5704 13.3641C5.90038 13.3641 5.36989 13.9502 5.36989 14.6825C5.36989 15.4232 5.90038 16.0009 6.5704 16.0009ZM13.4573 16.0009C14.1276 16.0009 14.6578 15.4232 14.6578 14.6825C14.6578 13.9499 14.1276 13.3641 13.4573 13.3641C12.7945 13.3641 12.2568 13.9502 12.2568 14.6825C12.2568 15.4232 12.7945 16.0009 13.4573 16.0009Z"
      fill="white"
    />
  </svg>
);

export const search = (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M14.6464 15.3545C14.8417 15.5498 15.1583 15.5498 15.3536 15.3545C15.5488 15.1593 15.5488 14.8427 15.3536 14.6474L10.9865 10.2803C11.3809 9.81311 11.7016 9.28704 11.9364 8.72026C12.2351 7.99905 12.3889 7.22606 12.3889 6.44542C12.3889 5.66479 12.2351 4.89179 11.9364 4.17058C11.6377 3.44937 11.1998 2.79406 10.6478 2.24206C10.0958 1.69007 9.4405 1.25221 8.71929 0.95347C7.99807 0.654734 7.22508 0.500977 6.44444 0.500977C5.66381 0.500977 4.89082 0.654734 4.1696 0.95347C3.44839 1.25221 2.79308 1.69007 2.24109 2.24206C1.68909 2.79406 1.25123 3.44937 0.952494 4.17058C0.653758 4.89179 0.5 5.66479 0.5 6.44542C0.5 7.22606 0.653758 7.99905 0.952494 8.72026C1.25123 9.44147 1.68909 10.0968 2.24109 10.6488C2.79308 11.2008 3.44839 11.6386 4.1696 11.9374C4.89082 12.2361 5.66381 12.3899 6.44444 12.3899C7.22508 12.3899 7.99807 12.2361 8.71929 11.9374C9.28606 11.7026 9.81214 11.3819 10.2794 10.9874L14.6464 15.3545Z"
      stroke="white"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const close = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="22"
    height="23"
    viewBox="0 0 22 23"
    fill="none"
  >
    <path
      d="M21.5004 1.01704C21.3462 0.862534 21.163 0.739954 20.9614 0.656319C20.7598 0.572683 20.5437 0.529632 20.3254 0.529632C20.1071 0.529632 19.891 0.572683 19.6893 0.656319C19.4877 0.739954 19.3046 0.862534 19.1504 1.01704L11.0004 9.15037L2.85037 1.00037C2.69607 0.846069 2.51289 0.723669 2.31128 0.640161C2.10967 0.556653 1.89359 0.513672 1.67537 0.513672C1.45716 0.513672 1.24107 0.556653 1.03947 0.640161C0.83786 0.723669 0.654676 0.846069 0.500372 1.00037C0.346069 1.15468 0.223669 1.33786 0.140161 1.53947C0.0566526 1.74107 0.0136719 1.95716 0.0136719 2.17537C0.0136719 2.39359 0.0566526 2.60967 0.140161 2.81128C0.223669 3.01289 0.346069 3.19607 0.500372 3.35037L8.65037 11.5004L0.500372 19.6504C0.346069 19.8047 0.223669 19.9879 0.140161 20.1895C0.0566526 20.3911 0.0136719 20.6072 0.0136719 20.8254C0.0136719 21.0436 0.0566526 21.2597 0.140161 21.4613C0.223669 21.6629 0.346069 21.8461 0.500372 22.0004C0.654676 22.1547 0.83786 22.2771 1.03947 22.3606C1.24107 22.4441 1.45716 22.4871 1.67537 22.4871C1.89359 22.4871 2.10967 22.4441 2.31128 22.3606C2.51289 22.2771 2.69607 22.1547 2.85037 22.0004L11.0004 13.8504L19.1504 22.0004C19.3047 22.1547 19.4879 22.2771 19.6895 22.3606C19.8911 22.4441 20.1072 22.4871 20.3254 22.4871C20.5436 22.4871 20.7597 22.4441 20.9613 22.3606C21.1629 22.2771 21.3461 22.1547 21.5004 22.0004C21.6547 21.8461 21.7771 21.6629 21.8606 21.4613C21.9441 21.2597 21.9871 21.0436 21.9871 20.8254C21.9871 20.6072 21.9441 20.3911 21.8606 20.1895C21.7771 19.9879 21.6547 19.8047 21.5004 19.6504L13.3504 11.5004L21.5004 3.35037C22.1337 2.71704 22.1337 1.65037 21.5004 1.01704Z"
      fill="#181818"
    />
  </svg>
);

export const arrow = (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16">
    <path d="M1.169,16c-.081-.019-.161-.037-.242-.056-.581-.138-.963-.649-.925-1.238.036-.553.511-1.043,1.094-1.067.449-.018.903.018,1.353.052,1.498.114,2.995.239,4.492.358,1.518.121,3.037.238,4.555.359.686.055,1.372.114,2.059.169.038.003.077-.009.156-.019-.066-.073-.106-.125-.153-.168-1.796-1.667-3.591-3.334-5.389-4.998-.442-.409-.902-.799-1.342-1.211C4.732,6.218,2.64,4.252.548,2.285.175,1.933-.087,1.532.031.981.21.141,1.172-.25,1.871.267c.337.249.62.574.909.882,1.708,1.813,3.409,3.632,5.116,5.446.408.433.836.848,1.242,1.282,1.752,1.873,3.5,3.751,5.247,5.628.046.049.076.113.114.17.026-.014.053-.028.079-.043,0-.07.005-.14,0-.209-.089-1.166-.179-2.332-.27-3.498-.105-1.352-.21-2.705-.315-4.057-.105-1.352-.219-2.704-.312-4.057-.022-.327-.023-.67.05-.987C13.855.289,14.347-.025,14.909.002c.497.024.946.415,1.04.927.036.196.049.399.049.599.003,4.558.002,9.115.002,13.673,0,.508-.077.619-.547.801H1.169Z" />
  </svg>
);

export const plus = (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
    <path d="M10.736 22.538c-.026.31-.05.635.077.918.145.324.49.547.843.544s.695-.231.835-.557c.098-.229.1-.486.099-.736l-.001-10.625c0-.189-.008-.4-.141-.534-.103-.104-.253-.133-.403-.14a2.885 2.885 0 0 0-.13-.003l-10.654.004c-.243 0-.494.002-.718.098-.317.138-.539.473-.543.819s.21.687.524.831c.276.127.595.106.898.083l10.153-.695" />
    <path d="M12.472 11.414c-.027.029.044-.649.047-.688.251-3.102.461-6.163.713-9.266.025-.31.048-.635-.08-.918-.145-.324-.491-.546-.844-.542s-.695.233-.833.56c-.097.229-.098.487-.097.736l.034 10.625c0 .189.01.4.143.534.104.104.253.132.404.139.044.002.088.002.13.002l10.654-.038c.243 0 .494-.003.718-.101.317-.138.537-.473.54-.82s-.212-.686-.526-.829c-.277-.126-.595-.104-.898-.08" />
  </svg>
);

export const minus = (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 1.996">
    <path d="M23.108 1.148c1.321-.072.855-.799.6-.938-.442-.241-1.165-.2-1.442-.208a9.804 9.804 0 0 0-.241-.003L2.331.005c-.45 0-.914.002-1.327.106C.418.259.008.619 0 .992s.388.739.968.895c.511.137 1.099.114 1.66.089l18.767-.748" />
  </svg>
);

export const trash = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="21"
    height="21"
    viewBox="0 0 21 21"
    fill="none"
  >
    <path
      d="M6.77097 2.73586C6.94112 2.24284 7.25664 1.81592 7.67406 1.51395C8.09147 1.21197 8.59022 1.0498 9.10156 1.0498C9.6129 1.0498 10.1117 1.21197 10.5291 1.51395C10.9465 1.81592 11.262 2.24284 11.4322 2.73586M16.1016 4.41985H2.10156M14.7287 6.52485L14.3499 12.3346C14.2042 14.5693 14.1317 15.6866 13.4193 16.3678C12.707 17.0498 11.6109 17.0498 9.42027 17.0498H8.78286C6.59227 17.0498 5.49615 17.0498 4.7838 16.3678C4.07144 15.6866 3.99815 14.5693 3.85321 12.3346L3.47439 6.52485M7.04274 8.62984L7.4545 12.8398M11.1604 8.62984L10.7486 12.8398"
      stroke="#2A1314"
      strokeLinecap="round"
    />
  </svg>
);

export const quote = (
  <svg
    width="61"
    height="48"
    viewBox="0 0 61 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M24.8592 48H0.5L4.08963 24.9873C6.65364 8.54758 16.2687 0 32.2948 0L30.6282 10.5201C21.7823 10.5201 17.6799 15.7802 16.5261 23.0137H28.7052L24.8592 48ZM32.2948 24.9863C34.8588 8.54759 44.4739 0 60.5 0L58.8334 10.5201C49.9875 10.5201 45.8851 15.7802 44.7313 23.0137H56.9114L53.0653 48H28.7062L32.2968 24.9873L32.2948 24.9863Z" />
  </svg>
);

export const navArrowLeft = (
  <svg
    width="23"
    height="24"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 125.255 123.955"
    transform="scale(-1,1)"
  >
    <path d="M66.153,122.201c-.404.246-.808.493-1.213.737-2.928,1.762-6.542,1.192-8.758-1.379-2.08-2.414-2.111-6.326.18-8.759,1.764-1.873,3.759-3.54,5.734-5.2,6.577-5.527,13.194-11.006,19.789-16.512,6.686-5.582,13.361-11.179,20.048-16.761,3.023-2.524,6.063-5.027,9.09-7.546.167-.139.278-.344.561-.704-.563-.036-.932-.089-1.3-.08-14.037.348-28.075.69-42.112,1.06-3.451.091-6.898.333-10.349.403-16.454.335-32.908.643-49.363.939-2.94.053-5.624-.548-7.359-3.278-2.646-4.164-.29-9.621,4.644-10.298,2.377-.327,4.842-.123,7.261-.021,14.267.605,28.533,1.262,42.8,1.875,3.408.146,6.824.134,10.232.29,14.691.676,29.38,1.386,44.07,2.094.386.019.767.159,1.15.243.05-.164.101-.327.151-.491-.281-.287-.544-.593-.845-.857-5.054-4.43-10.112-8.855-15.171-13.279-5.867-5.131-11.734-10.261-17.603-15.389-5.869-5.128-11.771-10.22-17.591-15.404-1.408-1.254-2.79-2.658-3.764-4.249-1.646-2.689-.897-5.951,1.503-8.089,2.126-1.894,5.531-2.084,7.975-.361.936.66,1.803,1.441,2.607,2.261,18.34,18.694,36.667,37.401,54.995,56.106,2.042,2.084,2.176,2.847.986,5.475-19.449,19.058-38.897,38.117-58.346,57.175Z" />
  </svg>
);

export const navArrowRight = (
  <svg
    width="23"
    height="24"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 125.255 123.955"
  >
    <path d="M66.153,122.201c-.404.246-.808.493-1.213.737-2.928,1.762-6.542,1.192-8.758-1.379-2.08-2.414-2.111-6.326.18-8.759,1.764-1.873,3.759-3.54,5.734-5.2,6.577-5.527,13.194-11.006,19.789-16.512,6.686-5.582,13.361-11.179,20.048-16.761,3.023-2.524,6.063-5.027,9.09-7.546.167-.139.278-.344.561-.704-.563-.036-.932-.089-1.3-.08-14.037.348-28.075.69-42.112,1.06-3.451.091-6.898.333-10.349.403-16.454.335-32.908.643-49.363.939-2.94.053-5.624-.548-7.359-3.278-2.646-4.164-.29-9.621,4.644-10.298,2.377-.327,4.842-.123,7.261-.021,14.267.605,28.533,1.262,42.8,1.875,3.408.146,6.824.134,10.232.29,14.691.676,29.38,1.386,44.07,2.094.386.019.767.159,1.15.243.05-.164.101-.327.151-.491-.281-.287-.544-.593-.845-.857-5.054-4.43-10.112-8.855-15.171-13.279-5.867-5.131-11.734-10.261-17.603-15.389-5.869-5.128-11.771-10.22-17.591-15.404-1.408-1.254-2.79-2.658-3.764-4.249-1.646-2.689-.897-5.951,1.503-8.089,2.126-1.894,5.531-2.084,7.975-.361.936.66,1.803,1.441,2.607,2.261,18.34,18.694,36.667,37.401,54.995,56.106,2.042,2.084,2.176,2.847.986,5.475-19.449,19.058-38.897,38.117-58.346,57.175Z" />
  </svg>
);

export const error = (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden
  >
    <path d="M10 0.958984C4.48 0.958984 0 5.37212 0 10.8097C0 16.2473 4.48 20.6605 10 20.6605C15.52 20.6605 20 16.2473 20 10.8097C20 5.37212 15.52 0.958984 10 0.958984ZM11 15.7351H9V9.82466H11V15.7351ZM11 7.85451H9V5.88436H11V7.85451Z" />
  </svg>
);

export const lightbulb = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="40"
    height="40"
    viewBox="0 0 40 40"
    fill="none"
  >
    <g clipPath="url(#clip0_45_4627)">
      <path
        d="M20.0002 2.5C16.7587 2.5 13.6499 3.7877 11.3578 6.07981C9.06569 8.37192 7.778 11.4807 7.778 14.7222C7.75939 16.4985 8.13906 18.2564 8.88911 19.8667C9.2601 20.5525 9.67581 21.2132 10.1336 21.8444C11.0236 23.0376 11.7695 24.3317 12.3558 25.7C12.759 27.1483 12.9793 28.6414 13.0113 30.1444H15.2336C15.199 28.3804 14.9338 26.6285 14.4447 24.9333C13.8029 23.3864 12.9746 21.9237 11.978 20.5778C11.5752 20.0291 11.2042 19.4578 10.8669 18.8667C10.2699 17.5601 9.97373 16.1362 10.0002 14.7C10.0002 12.0375 11.0579 9.48409 12.9405 7.60143C14.8232 5.71878 17.3766 4.66111 20.0391 4.66111C22.7016 4.66111 25.255 5.71878 27.1377 7.60143C29.0203 9.48409 30.078 12.0375 30.078 14.7C30.08 16.1506 29.7533 17.5827 29.1224 18.8889C28.7851 19.4801 28.4142 20.0514 28.0113 20.6C27.0202 21.9396 26.1956 23.3947 25.5558 24.9333C25.0647 26.6357 24.7995 28.3952 24.7669 30.1667H26.9891C27.0212 28.6636 27.2414 27.1705 27.6447 25.7222C28.2309 24.354 28.9768 23.0598 29.8669 21.8667C30.3263 21.2211 30.742 20.5455 31.1113 19.8444C31.8614 18.2342 32.2411 16.4763 32.2224 14.7C32.2166 11.4623 30.9263 8.35925 28.6348 6.07195C26.3433 3.78464 23.2379 2.49999 20.0002 2.5Z"
        fill="#252A8D"
      />
      <path
        d="M20.6983 17.2332C20.5316 17.067 20.3059 16.9736 20.0705 16.9736C19.8351 16.9736 19.6093 17.067 19.4427 17.2332L16.1094 20.5666L19.2872 24.0443V30.1999H21.1094V23.3332L18.6205 20.611L20.7205 18.511C20.8047 18.4266 20.8712 18.3262 20.9158 18.2156C20.9604 18.105 20.9824 17.9866 20.9803 17.8674C20.9782 17.7482 20.9522 17.6306 20.9037 17.5216C20.8553 17.4127 20.7854 17.3146 20.6983 17.2332Z"
        fill="#252A8D"
      />
      <path
        d="M26.5109 32.3889H13.4553C13.2195 32.3889 12.9935 32.4826 12.8268 32.6493C12.6601 32.816 12.5664 33.0421 12.5664 33.2778C12.5664 33.5136 12.6601 33.7396 12.8268 33.9063C12.9935 34.073 13.2195 34.1667 13.4553 34.1667H26.5109C26.7466 34.1667 26.9727 34.073 27.1394 33.9063C27.3061 33.7396 27.3997 33.5136 27.3997 33.2778C27.3997 33.0421 27.3061 32.816 27.1394 32.6493C26.9727 32.4826 26.7466 32.3889 26.5109 32.3889Z"
        fill="#252A8D"
      />
      <path
        d="M24.4457 35.7222H15.5569C15.3211 35.7222 15.095 35.8158 14.9283 35.9825C14.7616 36.1492 14.668 36.3753 14.668 36.6111C14.668 36.8468 14.7616 37.0729 14.9283 37.2396C15.095 37.4063 15.3211 37.4999 15.5569 37.4999H24.4457C24.6815 37.4999 24.9076 37.4063 25.0743 37.2396C25.241 37.0729 25.3346 36.8468 25.3346 36.6111C25.3346 36.3753 25.241 36.1492 25.0743 35.9825C24.9076 35.8158 24.6815 35.7222 24.4457 35.7222Z"
        fill="#252A8D"
      />
      <path
        d="M19.244 12.0999L16.2106 15.1332C16.0574 15.3023 15.9751 15.5239 15.9807 15.752C15.9864 15.9801 16.0795 16.1973 16.2408 16.3586C16.4022 16.52 16.6194 16.6131 16.8475 16.6187C17.0756 16.6243 17.2971 16.542 17.4662 16.3888L20.4995 13.3332C20.5888 13.2524 20.6606 13.1543 20.7108 13.0448C20.761 12.9353 20.7883 12.8168 20.7913 12.6964C20.7943 12.576 20.7728 12.4563 20.728 12.3445C20.6833 12.2327 20.6164 12.1311 20.5312 12.046C20.4461 11.9608 20.3445 11.8939 20.2327 11.8492C20.1209 11.8045 20.0012 11.783 19.8808 11.7859C19.7604 11.7889 19.6419 11.8163 19.5324 11.8664C19.423 11.9166 19.3248 11.9885 19.244 12.0777V12.0999Z"
        fill="#252A8D"
      />
    </g>
    <defs>
      <clipPath id="clip0_45_4627">
        <rect width="40" height="40" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const info = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="40"
    height="40"
    viewBox="0 0 40 40"
    fill="none"
  >
    <g clipPath="url(#clip0_74_2571)">
      <path
        d="M28.2118 28.2778C27.9654 28.118 27.6659 28.0623 27.3786 28.1226C27.0913 28.183 26.8396 28.3546 26.6784 28.6C25.1118 31 22.234 33.9445 19.6673 34.9334C17.1006 35.9222 15.0895 35.5667 14.2895 34.9334C13.9451 34.6334 13.0451 33.8222 13.8118 31.0556C14.3229 29.2111 17.5006 20.5222 18.2562 18.4111L15.834 18.7222C15.0673 20.7889 12.1784 28.5445 11.6562 30.4778C10.9006 33.2445 11.2784 35.2556 12.8673 36.6556C13.9778 37.4337 15.3122 37.8278 16.6673 37.7778C17.9824 37.7596 19.2825 37.4958 20.5006 37C23.6006 35.7889 26.8562 32.4222 28.5673 29.8111C28.6449 29.6872 28.6972 29.5491 28.7214 29.4049C28.7455 29.2607 28.7409 29.1131 28.7079 28.9707C28.6748 28.8282 28.614 28.6937 28.5289 28.5748C28.4437 28.4559 28.336 28.355 28.2118 28.2778Z"
        fill="#252A8D"
      />
      <path
        d="M21.4453 12.2222C22.4342 12.2222 23.4009 11.9289 24.2232 11.3795C25.0454 10.8301 25.6863 10.0492 26.0647 9.13559C26.4431 8.22196 26.5422 7.21662 26.3492 6.24672C26.1563 5.27681 25.6801 4.3859 24.9808 3.68664C24.2816 2.98737 23.3907 2.51117 22.4208 2.31824C21.4509 2.12532 20.4455 2.22433 19.5319 2.60277C18.6183 2.98121 17.8374 3.62207 17.288 4.44432C16.7386 5.26656 16.4453 6.23326 16.4453 7.22217C16.4453 8.54825 16.9721 9.82002 17.9098 10.7577C18.8475 11.6954 20.1192 12.2222 21.4453 12.2222ZM21.4453 4.44439C21.9947 4.44439 22.5318 4.60731 22.9886 4.91253C23.4454 5.21776 23.8014 5.65159 24.0116 6.15916C24.2219 6.66673 24.2769 7.22525 24.1697 7.76409C24.0625 8.30292 23.798 8.79788 23.4095 9.18636C23.021 9.57484 22.5261 9.83939 21.9872 9.94657C21.4484 10.0538 20.8899 9.99875 20.3823 9.7885C19.8747 9.57826 19.4409 9.22222 19.1357 8.76542C18.8304 8.30862 18.6675 7.77156 18.6675 7.22217C18.6675 6.48546 18.9602 5.77892 19.4811 5.25798C20.0021 4.73705 20.7086 4.44439 21.4453 4.44439Z"
        fill="#252A8D"
      />
      <path
        d="M13.121 16.6667C13.1877 16.6667 20.0877 15.7556 21.7099 15.5556C22.4321 15.4445 22.9765 15.5556 23.1543 15.7223C23.3321 15.889 23.3877 16.6112 23.0765 17.589C22.3988 19.6556 18.9765 29.8112 17.9765 32.8223C18.4653 32.722 18.9448 32.5808 19.4099 32.4001C19.8547 32.2162 20.2824 31.9931 20.6877 31.7334C22.0543 27.7778 24.6099 20.1112 25.1877 18.3556C25.7654 16.6001 25.621 15.2667 24.8543 14.3556C24.417 13.9122 23.8695 13.5931 23.2681 13.431C22.6667 13.2689 22.0331 13.2698 21.4321 13.4334C19.8432 13.6001 13.1321 14.4778 12.8432 14.5445C12.5485 14.5828 12.2811 14.7366 12.0998 14.9721C11.9186 15.2075 11.8382 15.5054 11.8765 15.8001C11.9149 16.0947 12.0687 16.3621 12.3041 16.5434C12.5396 16.7247 12.8374 16.805 13.1321 16.7667L13.121 16.6667Z"
        fill="#252A8D"
      />
    </g>
    <defs>
      <clipPath id="clip0_74_2571">
        <rect width="40" height="40" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const footerLogo = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="231"
    height="45"
    viewBox="0 0 231 45"
    fill="none"
  >
    <g clipPath="url(#clip0_311_15)">
      <path
        d="M25.1142 34.706H0.5V1.42163H7.13922V28.9951H25.1142V34.706Z"
        fill="white"
      />
      <path
        d="M20.0845 11.1765H27.068L33.2399 28.3088L39.338 11.1765H46.3459L35.2067 37.9167C33.3134 42.4264 30.4118 45 25.3463 45C23.4529 45 21.8792 44.4852 20.8463 43.9704L21.6331 38.9214C22.4445 39.2646 23.5511 39.5342 24.6084 39.5342C27.2394 39.5342 29.1083 37.6959 29.846 34.7303L20.084 11.1763L20.0845 11.1765Z"
        fill="white"
      />
      <path
        d="M49.6283 26.3234C51.0546 28.5292 53.4644 29.9508 55.8495 29.9508C57.7429 29.9508 59.2182 29.2156 59.2182 27.892C59.2182 26.642 57.9641 26.2007 55.0872 25.5635C49.9233 24.4116 46.284 22.7695 46.284 17.9409C46.284 13.529 50.366 10.686 55.5052 10.686C60.3002 10.686 63.2755 13.0391 64.9723 15.5881L60.9397 18.8969C59.9068 17.2548 58.1612 15.9802 55.653 15.9802C53.6121 15.9802 52.2105 16.6909 52.2105 17.8674C52.2105 19.142 53.7105 19.5587 56.6368 20.2694C61.8988 21.544 65.2431 23.2351 65.2431 27.892C65.2431 32.3282 60.9646 35.1961 55.9238 35.1961C51.2763 35.1961 47.5387 33.0637 45.3994 29.7303L49.6288 26.3234H49.6283Z"
        fill="white"
      />
      <path
        d="M64.7119 11.1765H71.4002L77.5477 28.5541L83.6704 11.1765H90.3587L81.3835 34.7059H73.7116L64.7119 11.1765Z"
        fill="white"
      />
      <path
        d="M89.584 22.9165C89.6087 15.7351 94.7232 10.686 101.731 10.686C108.223 10.686 113.165 15.0242 113.165 22.1566C113.165 23.0145 113.092 23.8968 112.944 24.8283H95.8789C96.346 27.5978 99.1739 29.5341 102.174 29.5341C104.51 29.5341 106.526 28.4557 108.051 26.2253L112.526 29.5587C110.313 33.2351 106.182 35.2204 102.026 35.2204C94.4527 35.2204 89.584 29.7792 89.584 22.9165ZM107.288 20.6126C106.969 17.9901 104.805 15.9802 101.805 15.9802C98.6821 15.9802 96.3214 17.9409 95.9771 20.6126H107.288H107.288Z"
        fill="white"
      />
      <path
        d="M119.078 0C121.218 0 122.718 1.47054 122.718 3.62743C122.718 5.75974 121.218 7.23028 119.078 7.23028C116.939 7.23028 115.464 5.75974 115.464 3.62743C115.464 1.49513 116.939 0 119.078 0ZM115.956 34.706V11.1766H122.275V34.706H115.956Z"
        fill="white"
      />
      <path
        d="M133.056 34.7061H126.761V0.196289H133.056V34.7061Z"
        fill="white"
      />
      <path
        d="M135.821 22.9165C135.846 15.7351 140.961 10.686 147.968 10.686C154.46 10.686 159.403 15.0242 159.403 22.1566C159.403 23.0145 159.329 23.8968 159.181 24.8283H142.116C142.583 27.5978 145.411 29.5341 148.411 29.5341C150.747 29.5341 152.763 28.4557 154.288 26.2253L158.763 29.5587C156.55 33.2351 152.419 35.2204 148.264 35.2204C140.69 35.2204 135.821 29.7792 135.821 22.9165ZM153.526 20.6126C153.206 17.9901 151.042 15.9802 148.042 15.9802C144.919 15.9802 142.559 17.9409 142.214 20.6126H153.526Z"
        fill="white"
      />
      <path
        d="M171.93 10.6865C175.717 10.6865 178.151 12.059 179.725 14.0199V0.196289H185.922V34.7061H179.725L179.602 32.206C178.028 34.0197 175.397 35.1963 171.93 35.1963C165.242 35.1963 160.496 30.0248 160.496 22.9169C160.496 15.7601 165.242 10.6865 171.93 10.6865ZM166.84 22.8923C166.84 26.6179 169.471 29.5589 173.233 29.5589C176.946 29.5589 179.651 26.6179 179.651 22.8923C179.651 19.1422 176.947 16.3238 173.233 16.3238C169.471 16.3238 166.84 19.0933 166.84 22.8923Z"
        fill="white"
      />
      <path
        d="M188.687 22.9165C188.711 15.7351 193.826 10.686 200.834 10.686C207.325 10.686 212.268 15.0242 212.268 22.1566C212.268 23.0145 212.194 23.8968 212.047 24.8283H194.981C195.449 27.5978 198.276 29.5341 201.276 29.5341C203.612 29.5341 205.629 28.4557 207.153 26.2253L211.629 29.5587C209.416 33.2351 205.285 35.2204 201.129 35.2204C193.555 35.2204 188.687 29.7792 188.687 22.9165ZM206.391 20.6126C206.071 17.9901 203.907 15.9802 200.907 15.9802C197.785 15.9802 195.424 17.9409 195.08 20.6126H206.391Z"
        fill="white"
      />
      <path
        d="M215.058 11.1765H221.156L221.279 14.3872C222.484 11.9363 224.771 10.6863 227.426 10.6863C228.828 10.6863 230.008 11.054 230.5 11.2254L230.008 16.8381C229.369 16.6176 228.336 16.299 227.082 16.299C224.303 16.299 221.377 17.7941 221.377 22.647V34.7059H215.058V11.1765Z"
        fill="white"
      />
    </g>
  </svg>
);

export const email = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24ZM5 12C5 8.136 8.136 5 12 5C15.864 5 19 8.136 19 12V13.001C19 14.38 17.929 15.5 16.55 15.5C15.717 15.5 14.933 15.094 14.478 14.471C13.848 15.108 12.966 15.5 12 15.5C10.068 15.5 8.5 13.932 8.5 12C8.5 10.068 10.068 8.5 12 8.5C13.932 8.5 15.5 10.068 15.5 12V13.001C15.5 13.554 15.997 14.1 16.55 14.1C17.103 14.1 17.6 13.554 17.6 13.001V12C17.6 8.962 15.038 6.4 12 6.4C8.962 6.4 6.4 8.962 6.4 12C6.4 15.038 8.962 17.6 12 17.6H15.5V19H12C8.136 19 5 15.864 5 12ZM9.9 12C9.9 13.162 10.838 14.1 12 14.1C13.162 14.1 14.1 13.162 14.1 12C14.1 10.838 13.162 9.9 12 9.9C10.838 9.9 9.9 10.838 9.9 12Z"
      fill="white"
    />
  </svg>
);

export const facebook = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24ZM14.3333 13.05H12.6667V19H10V13.05H8V10.25H10V8.29C10 6.1599 11.2853 5 13.0953 5C13.962 5 14.7827 5.0679 15 5.098V7.45H14C12.6667 7.45 12.6667 8.129 12.6667 8.85V10.25H15L14.3333 13.05Z"
      fill="white"
    />
  </svg>
);

export const instagram = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24ZM9.29865 5.33301H14.6787C15.7299 5.33407 16.7378 5.75209 17.4812 6.49536C18.2246 7.23863 18.6427 8.24644 18.644 9.29768V14.6777C18.6429 15.7289 18.2249 16.7368 17.4816 17.4802C16.7384 18.2236 15.7305 18.6418 14.6793 18.643H9.29932C8.24809 18.642 7.2402 18.2239 6.49681 17.4807C5.75341 16.7374 5.33522 15.7296 5.33398 14.6783V9.29834C5.33504 8.24711 5.75307 7.23923 6.49634 6.49583C7.23961 5.75244 8.24742 5.33424 9.29865 5.33301ZM17.1054 15.6829C17.2374 15.3642 17.3053 15.0226 17.3053 14.6777V9.29834C17.3053 8.60182 17.0287 7.93382 16.5362 7.44124C16.0438 6.94867 15.3758 6.67185 14.6793 6.67167H9.29932C8.6028 6.67167 7.9348 6.94832 7.44222 7.44077C6.94964 7.93322 6.67283 8.60116 6.67265 9.29768V14.6777C6.67265 15.3742 6.9493 16.0422 7.44175 16.5348C7.9342 17.0273 8.60213 17.3042 9.29865 17.3043H14.6787C15.0236 17.3043 15.3652 17.2364 15.6838 17.1044C16.0025 16.9724 16.2921 16.7789 16.536 16.535C16.7799 16.2911 16.9734 16.0015 17.1054 15.6829ZM11.9882 8.5459C11.0758 8.54731 10.2012 8.91042 9.55614 9.55564C8.91105 10.2008 8.54811 11.0755 8.54688 11.9879C8.54793 12.9005 8.91089 13.7754 9.55614 14.4208C10.2014 15.0662 11.0763 15.4293 11.9889 15.4306C12.9016 15.4295 13.7766 15.0665 14.422 14.4211C15.0674 13.7757 15.4305 12.9006 15.4315 11.9879C15.4301 11.0753 15.0668 10.2005 14.4213 9.55536C13.7758 8.91023 12.9008 8.54745 11.9882 8.54657V8.5459ZM11.9882 14.0919C11.4304 14.0919 10.8954 13.8703 10.5009 13.4758C10.1065 13.0814 9.88488 12.5464 9.88488 11.9886C9.88488 11.4307 10.1065 10.8957 10.5009 10.5013C10.8954 10.1068 11.4304 9.88523 11.9882 9.88523C12.546 9.88523 13.081 10.1068 13.4755 10.5013C13.8699 10.8957 14.0915 11.4307 14.0915 11.9886C14.0915 12.5464 13.8699 13.0814 13.4755 13.4758C13.081 13.8703 12.546 14.0919 11.9882 14.0919ZM16.2627 8.57167C16.2627 9.02713 15.8934 9.39634 15.438 9.39634C14.9825 9.39634 14.6133 9.02713 14.6133 8.57167C14.6133 8.11622 14.9825 7.74701 15.438 7.74701C15.8934 7.74701 16.2627 8.11622 16.2627 8.57167Z"
      fill="white"
    />
  </svg>
);

export const linkedin = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24ZM8.23661 8.27564C8.48678 8.02571 8.62743 7.68665 8.6276 7.33302C8.62778 6.9794 8.48748 6.64019 8.23755 6.39002C7.98763 6.13985 7.64856 5.9992 7.29494 5.99902C6.94132 5.99885 6.60211 6.13915 6.35193 6.38908C6.10176 6.639 5.96111 6.97807 5.96094 7.33169C5.96076 7.68531 6.10107 8.02452 6.35099 8.27469C6.60091 8.52487 6.93998 8.66551 7.2936 8.66569C7.64723 8.66587 7.98644 8.52556 8.23661 8.27564ZM6.00094 9.65302H8.6676V17.9997H6.00094V9.65302ZM10.2276 9.65302H12.8809L12.8543 10.773C13.9609 8.75302 18.6676 8.59969 18.6676 12.713V17.9997H16.0343V13.6197C16.0343 10.953 12.8543 11.1797 12.8543 13.6197V17.9997H10.2276V9.65302Z"
      fill="white"
    />
  </svg>
);

export const breadcrumb = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="10"
    height="14"
    viewBox="0 0 10 14"
    fill="none"
  >
    <path
      d="M9.53674e-07 0.700422V13.3008C0.000382423 13.4284 0.0339508 13.5534 0.0970926 13.6625C0.160234 13.7715 0.250558 13.8605 0.358341 13.9197C0.466125 13.979 0.587288 14.0063 0.708787 13.9988C0.830285 13.9912 0.947519 13.9491 1.04787 13.8769L9.73002 7.57672C10.09 7.31561 10.09 6.68699 9.73002 6.42518L1.04787 0.125005C0.947729 0.0520805 0.830436 0.00931579 0.708735 0.00135729C0.587033 -0.00660121 0.465579 0.0205509 0.357567 0.0798637C0.249555 0.139176 0.159116 0.228381 0.096076 0.337786C0.0330372 0.447191 -0.000190735 0.572612 9.53674e-07 0.700422Z"
      fill="#F7C546"
    />
  </svg>
);

export const angle = (
  <svg
    width="22"
    height="40"
    viewBox="0 0 22 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      id="Vector"
      d="M21.4804 18.7539L2.81119 0.475364C2.49968 0.170223 2.08583 0 1.65546 0C1.22509 0 0.811235 0.170223 0.499731 0.475364L0.47963 0.496017C0.328094 0.643943 0.20743 0.822 0.124975 1.01936C0.0425205 1.21671 0 1.42924 0 1.64402C0 1.85879 0.0425205 2.07132 0.124975 2.26868C0.20743 2.46604 0.328094 2.64409 0.47963 2.79202L18.0601 20.0034L0.47963 37.208C0.328094 37.3559 0.20743 37.534 0.124975 37.7313C0.0425205 37.9287 0 38.1412 0 38.356C0 38.5708 0.0425205 38.7833 0.124975 38.9806C0.20743 39.178 0.328094 39.3561 0.47963 39.504L0.499731 39.5246C0.811235 39.8298 1.22509 40 1.65546 40C2.08583 40 2.49968 39.8298 2.81119 39.5246L21.4804 21.2461C21.6446 21.0854 21.7753 20.892 21.8646 20.6778C21.9539 20.4636 22 20.233 22 20C22 19.767 21.9539 19.5364 21.8646 19.3222C21.7753 19.108 21.6446 18.9146 21.4804 18.7539Z"
      fill="#051A24"
    />
  </svg>
);

export const magnifyingGlass = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
  >
    <path
      d="M17 17L11.6667 11.6667M1 7.22222C1 8.03934 1.16094 8.84845 1.47364 9.60336C1.78633 10.3583 2.24466 11.0442 2.82245 11.622C3.40023 12.1998 4.08617 12.6581 4.84108 12.9708C5.596 13.2835 6.40511 13.4444 7.22222 13.4444C8.03934 13.4444 8.84845 13.2835 9.60336 12.9708C10.3583 12.6581 11.0442 12.1998 11.622 11.622C12.1998 11.0442 12.6581 10.3583 12.9708 9.60336C13.2835 8.84845 13.4444 8.03934 13.4444 7.22222C13.4444 6.40511 13.2835 5.596 12.9708 4.84108C12.6581 4.08617 12.1998 3.40023 11.622 2.82245C11.0442 2.24466 10.3583 1.78633 9.60336 1.47364C8.84845 1.16094 8.03934 1 7.22222 1C6.40511 1 5.596 1.16094 4.84108 1.47364C4.08617 1.78633 3.40023 2.24466 2.82245 2.82245C2.24466 3.40023 1.78633 4.08617 1.47364 4.84108C1.16094 5.596 1 6.40511 1 7.22222Z"
      stroke="#181818"
      strokeOpacity="0.6"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
